<template>
    <div>
        <van-row class="panel">
            <van-col span="4">
                <div class="item-left">
                    <div>
                        <span class="price-label">￥</span>
                        <span class="price-val">{{parseInt(p_info.money)}}</span>
                    </div>
                    <div class="text-info">{{p_info.limit_type_name}}</div>
                </div>
            </van-col>
            <van-col span="16">
                <div class="center">
                    <div class="main-name">{{p_info.name}}</div>
                    <div class="order-time">
                        <span>有效期至</span>
                        <span>{{moment.unix(p_info.deadline).format('YYYY-MM-DD')}}</span>
                    </div>
                </div>
            </van-col>
            <van-col >
                <div class="right" v-if="!p_show_button">
                    <img src="../../assets/gotit.png" />
                </div>
                <div class="right" v-if="p_show_button && p_info.status==10">
                    <van-button class="button" type="primary" size="mini" @click="use_coupon">立即使用</van-button>
                </div>
                <div class="right" v-if="p_show_button && p_info.status==20">
                    <img src="../../assets/used.png" />
                </div>
                <div class="right" v-if="p_show_button && p_info.status==30">
                    <img src="../../assets/expired.png" />
                </div>
            </van-col>
        </van-row>
    </div>
</template>

<script>
    export default {
        name: "CouponItem",
        props:{
            p_info:{
                type:Object,
                default:null,
                required:true,
            },
            p_show_button:{
                type:Boolean,
                default:true,
                required:false,
            }
        },
        computed:{
            countDownTime(){
                let now_time = parseInt(new Date().getTime());
                return parseInt(this.p_info.deadline)*1000 - now_time;
            }
        },
        data(){
            return{
                moment:this.$moment,
            }
        },
        methods:{
            use_coupon(){
                // let ids=this.p_info.id;
                // let lock_area=1;
                // this.$router.push({name:'CreateOrderBatch',params:{ids,lock_area}});

                //hzh 2020-12-11 改为单张处理模式
                let product_id=this.p_info.product_id;
                let sales_uid=this.p_info.sales_uid;
                let coupon_id=this.p_info.id;
                this.$router.push({name:'CreateOrder',params:{product_id,sales_uid,coupon_id}});
            }
        }
    }
</script>

<style lang="scss" scoped>
    .panel{
        background-color: #FFFFFF;
        margin: 8px;
        border-radius: 6px;
        display: flex;
        height: 90px;
        .item-left{
            margin-top: 20%;
            .price-label{
                font-size: 14px;
                color: #E34928;
            }
            .price-val{
                font-size: 26px;
                font-weight: bold;
                color: #E34928;
            }
            .text-info{
                font-size: 12px;
                color: #E34928;
            }
        }
        .center{
            text-align: left;
            padding-left: 14px;
            .main-name{
                padding-top: 10px;
                font-size: 14px;
                color: #666666;
            }
            .order-time{
                padding-top: 8px;
                span{
                    float: left;
                    font-size: 12px;
                    padding-right: 8px;
                }
            }
        }
        .right{
            margin-top: 30%;
            img{
                height: 60px;
            }
            .button{
                margin-top: 12px;
                margin-left: 4px;
            }
        }
    }
</style>
